//Api service
import api from "../config/api";

export const fetchVendor = async() => {
    const res =await api.get(`/vendor/`);
    return res.data.data;
}
export const createVendor = async(formData)=> {
    const res = await api.post(`/vendor/`, formData);
    return res.data.data
}
export const updateVendor = async(id, data)=> {
    const res = await api.post(`/vendor/?id=${id}`, data);
    return res.data.data
}
export const deleteVendor =async (id)=> {
    const res = await api.delete(`/vendor/?id=${id}`);
    return res.data.data;
}
